module.exports = __webpack_public_path__ + "img/home2.76bf6ba8.jpeg";